import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import Education from "../Forms/D/Education/Education"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const EducationContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingEducation, setIsGettingEducation] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingEducation(true)
      handleSubmitGet(endpoints.GET_EDUCATION_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
        organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.EDUCATION,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.EDUCATION)
          handleLoadPrev(false)
          setIsGettingEducation(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingEducation(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_d_1: data?.form?.gpraD1 ?? "",
      gpra_d_2: data?.form?.gpraD2 ?? "",
      gpra_d_2a: data?.form?.gpraD2a ?? "",
      gpra_d_3: data?.form?.gpraD3 ?? "",
      gpra_d_3a: data?.form?.gpraD3a ?? "",
      gpra_d_4: loadEnoughMoney(data?.form),
      gpra_d_5: data?.form?.gpraD5 ?? "",
      gpra_d_id: data?.form?.gpraDId ?? 0,
      additional: data?.additional,
    }
  }
  const loadEnoughMoney = (data) => {
    let enoughMoney = []
    data?.gpraD4a && enoughMoney.push(data.gpraD4a)
    data?.gpraD4b && enoughMoney.push(data.gpraD4b)
    data?.gpraD4c && enoughMoney.push(data.gpraD4c)
    data?.gpraD4d && enoughMoney.push(data.gpraD4d)
    data?.gpraD4e && enoughMoney.push(data.gpraD4e)
    data?.gpraD4f && enoughMoney.push(data.gpraD4f)
    data?.gpraD4g && enoughMoney.push(data.gpraD4g)
    data?.gpraD4h && enoughMoney.push(data.gpraD4h)
    data?.gpraD4i && enoughMoney.push(data.gpraD4i)
    data?.gpraD4j && enoughMoney.push(data.gpraD4j)
    return enoughMoney
  }
  if (isGettingEducation) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingEducation && (
        <Education showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default EducationContainer
